import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { ErrorLike } from '@apollo/client';
import { ListingsSearchQuery } from '@gql';
export interface SearchResultsContextValue {
  listingsQueryResults?: ListingsSearchQuery;
  listingsLoading: boolean;
  listingsError?: ErrorLike;
  retrySearch: () => void;
  isGeoResolutionError: boolean;
  resetPagination: VoidFunction;
  nextPage: () => void;
  prevPage: () => void;
  placeId: string | null;
  placeName: string | null;
}
const SearchResultsContext = React.createContext<SearchResultsContextValue | undefined>(undefined);
interface SearchResultsProviderProps {
  value: SearchResultsContextValue;
  children: React.ReactNode;
}
export const SearchResultsProvider: React.FC<SearchResultsProviderProps> = t0 => {
  const $ = _c(3);
  const {
    value,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = <SearchResultsContext.Provider value={value}>{children}</SearchResultsContext.Provider>;
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const useSearchResults = () => {
  const context = React.useContext(SearchResultsContext);
  if (context === undefined) {
    throw new Error("useSearchResults must be used within a SearchProvider");
  }
  return context;
};